import { Component, OnInit, ViewChild, ViewContainerRef, Output, EventEmitter, AfterViewInit, Input } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { FacilitySearchSelectModel } from '../../services/dashboard.service';

export interface FilterState {
  fy: string;
  timezone: string;
  timezoneOffset: number;
  facilityId: any;
  facilityChange:boolean;
}

@Component({
    selector: 'dashboard-filters',
    templateUrl: './dashboard-filters.component.html',
    styleUrls: ['./dashboard-filters.component.scss'] // Optional if you have styles
    ,
    standalone: false
})
export class DashboardFiltersComponent implements OnInit, AfterViewInit {
  @ViewChild('selectComponent', { read: ViewContainerRef, static: false }) selectComponent: ViewContainerRef;
  @Input() widgetData:any={}
  // Emit changes to the parent (PowerBI or Superset)
  @Output() filterChanged: EventEmitter<FilterState> = new EventEmitter();

  facilitySearchSelect: FacilitySearchSelectModel;
  
  financialYears: string[] = [];
  selectedFY: string;
  
  timezones: any[] = [];
  timezonesObj: any[] = []; // Key-value pair for easy lookup
  selectedTimezone: string = 'Asia/Kolkata'; 

  selectedFacilityId: any = null;

  constructor(
    private baseService: BaseService,
    private appService: AppService,
    public alerts: AlertsService
  ) {
    this.facilitySearchSelect = new FacilitySearchSelectModel();
    this.initFinancialYears();
  }

  ngOnInit() {
    // 1. Load Timezones
    this.getTimezoneAndBuildDefaultFilter((success) => {
      if(success) {
        // 2. Once loaded, emit the initial state so parent can load the report
        this.emitState();
      }
    });
  }

  ngAfterViewInit() {
    // 3. Load Facility Dropdown
    if(this.appService.isFacilityAware()){
      if (this.appService._currentSessionData.facilityArray != undefined && this.appService._currentSessionData.facilityArray.length > 0) {
        this.facilitySearchSelect.datasource.possible_value = this.appService._currentSessionData.facilityArray;
        this.createComponent("kx-multiselect-dropdown");
      }
    }
  }

  // --- Logic Moved from Parent ---

  initFinancialYears() {
    const currentYear = new Date().getFullYear();
    for (let i = -3; i < 2; i++) {
      const start = currentYear + i;
      const end = start + 1;
      this.financialYears.push(`${start}-${end}`);
    }
    const month = new Date().getMonth();
    const startY = month >= 3 ? currentYear : currentYear - 1;
    this.selectedFY = `${startY}-${startY + 1}`;
  }

  getTimeZoneAccount(){
    return this.appService._currentSessionData.timeZoneAccount
  }

  getTimezoneAndBuildDefaultFilter(callback){
    var datasource = {
        "application": "system-management",
        "resource": "valueset",
        "query_id": "get_valueset_by_id_flat",
        "args": "resourceId:timezone,system:karexpert"
    }
    this.baseService.getByDataSource(datasource).subscribe(
      (data: any) => {
        if (data.errCode == -1) {
          this.alerts.error(data.message);
          callback(false)
        } else {
          this.timezones = [];
          this.timezonesObj = [];
          
          for (let index = 0; index < data.resource.length; index++) {
            const element = data.resource[index];
            try{
              let obj = {
                "label":element.display,
                "value":element.code,
                "meta":JSON.parse(element.meta),
              }
              this.timezones.push(obj);
              this.timezonesObj[obj.value] = obj;
            } catch(e){
              console.error(e)
            }

            if(element.code == this.getTimeZoneAccount()){
              this.selectedTimezone = element.code;
            }
          }
          callback(true)
        }
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        callback(false)
      }
    )
  }

  createComponent(selector){
    this.baseService.createComponent(selector, this.selectComponent, (response) => {
      response.instance.settings = this.facilitySearchSelect.defaultsetting;
      response.instance.questions = this.facilitySearchSelect.question;
      response.instance.format = this.facilitySearchSelect.question.format;
      response.instance.data = this.facilitySearchSelect.datasource;
      response.instance.onSelect.subscribe((eventData) => {
          this.onFacilitySelect(eventData);
      });
      response.instance.onDeSelect.subscribe((eventData) => {
        this.onFacilitySelect(null);
      });
    });
  }

  // --- Event Handlers ---

  onFacilitySelect(event?: any) {
    this.selectedFacilityId = event ? event.id : null;
    this.emitState(true);
  }

  onFilterChange() {
    this.emitState();
  }

  // Helper to package data and send to parent
  emitState(facilityChange=false) {
    let offset = 5.5; // Default
    if(this.timezonesObj[this.selectedTimezone] != undefined){
      offset = this.timezonesObj[this.selectedTimezone]["meta"]["offset"];
    }

    const state: FilterState = {
      fy: this.selectedFY,
      timezone: this.selectedTimezone,
      timezoneOffset: offset,
      facilityId: this.selectedFacilityId,
      facilityChange:facilityChange
    };

    this.filterChanged.emit(state);
  }
}